














import Vue, { PropType } from 'vue';
import { Item } from 'mostra';
import {
  sizes,
  genDownloadImageUrlByImage,
} from '@/modules/image';

// interface DataType {
//   // item: ItemData | null;
//   // name: string;
//   // itemNumber: string;
//   // imageSrc: string | null;
//   // loading: boolean;
// }

export default Vue.extend({
  name: 'GItemInfoHeader',
  props: {
    // owner: { type: String as PropType<string>, required: true },
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
    // itemId: { type: String as PropType<string>, required: true },
    // items: { type: Array as PropType<Item[]>, required: true },
  },
  // data(): DataType {
  //   return {
  //     // item: null,
  //     // name: '',
  //     // itemNumber: '',
  //     imageSrc: '',
  //     // loading: false,
  //   };
  // },
  asyncComputed: {
    async imageSrc(): Promise<string | null> {
      const u = await genDownloadImageUrlByImage(
        sizes.x128,
        this.item.data.base.topImage,
      );
      return u;
    },
  },
  // methods: {
  //   // filterItem() {
  //   //   const filteredItem = this.items.find(({ id }) => id === this.itemId);
  //   //   if (!filteredItem) return;
  //   //   this.item = filteredItem.data;
  //   //   this.name = this.item.base.name;
  //   //   this.itemNumber = this.item.base.itemNumber;
  //   // },
  //   // async getImageSrc() {
  //   //   if (!this.item) {
  //   //     throw Error("this.item is null");
  //   //   }
  //   //   this.imageSrc = await genImageUrlByImage(sizes.x256, this.item.base.topImage);
  //   //   // if (!(this.item && this.item.base.topImage)) return;
  //   //   // const uid = this.$auth.uid;
  //   //   // const cid = this.$auth.cid;
  //   //   try {
  //   //     // this.loading = true;
  //   //     // const imageId = this.item.base.topImage.id;
  //   //     // if (!imageId) return;
  //   //     // this.imageSrc = await genDownloadOriginalImageUrlEx(this.owner, imageId);
  //   //   } catch (error) {
  //   //     console.log(error);
  //   //   } finally {
  //   //     // this.loading = false;
  //   //   }
  //   // },
  // },
  // async mounted() {
  //   await this.filterItem();
  //   await this.getImageSrc();
  // },
});
